import * as React from "react";
import { connect } from "react-redux";

import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Provider } from "react-redux";
import ReactTooltip from "react-tooltip";

import "./App.scss";
import "../../node_modules/react-big-calendar/lib/css/react-big-calendar.css";
import "../../node_modules/office-ui-fabric-core/dist/sass/Fabric.scss";
import "react-toastify/dist/ReactToastify.css";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import DashboardView from "./components/dashboard/DashboardView";
import { getAuth, getTeacherState, renewAuth } from "./actions/Action_Teacher";
import { getStudentState } from "./actions/Action_Student";
import { SplashScreenView } from "./components/loading/SplashScreen";
import ErrorBoundary from "./components/shared/ErrorBoundary";
// Register icons and pull the fonts from the default SharePoint cdn.
<ReactTooltip />;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: "6d6312d0-b027-4a25-a4fb-93baee98499a",
    /* ...Other Configuration Options... */
  },
});
appInsights.loadAppInsights();

enum AuthorizationRequestStatus {
  NotStarted = "NotStarted",
  Requesting = "Requesting",
  Success = "Success",
  Failed = "Failed",
}

interface IAppProps {
  getAuth: (tokenData: any) => any;
  renewAuth: () => any;
  getTeacherState: () => any;
  getStudentState: () => any;
  role: string;
}

interface IAppState {
  authorizationRequestStatus: AuthorizationRequestStatus;
  showlogin: boolean;
  expirytime: string;
}
const jwtDecode = require("jwt-decode");
import * as moment from "moment";
import axios from "axios";
import { Providers } from "@microsoft/mgt";
import {
  Dialog,
  DialogFooter,
  DialogType,
  ActionButton,
} from "office-ui-fabric-react";
import { getQueryParam } from "./utils/HelperFunctions";

class App extends React.Component<IAppProps, IAppState> {
  constructor(props) {
    super(props);

    this.state = {
      authorizationRequestStatus: AuthorizationRequestStatus.NotStarted,
      showlogin: false,
      expirytime: "",
    };
  }

  componentDidMount() {
    try {
      document.getElementById('errorlog').innerHTML += '<br>authenticating';
      this.authenticate();
      console.log("auth done");
    } catch (exception) {
      console.log(exception);
      alert(exception);
    }
    // axios.interceptors.request.use(
    //   async (config) => {
    //     if(localStorage.getItem("id_token"))
    //     {
    //       try{
    //         const tokenExpirationTime = moment(
    //           jwtDecode(localStorage.getItem("id_token")).exp,
    //           "DD/MM/YYYY H:mm"
    //         ).unix();
    //         const expiryasstring = moment(
    //           jwtDecode(localStorage.getItem("id_token")).exp,
    //           "DD/MM/YYYY H:mm"
    //         ).toLocaleString();
    //         console.log("expiryasstring", expiryasstring);
    //         const expiryThreshold = moment().add(-2, "hours").unix();
    //         console.log(
    //           "expirythresholdasstring",
    //           moment().add(-2, "hours").toLocaleString()
    //         );
    
    //         console.log("tokenExpirationTime", tokenExpirationTime);
    //         console.log("expiryThreshold", expiryThreshold);
    //         if (
    //           tokenExpirationTime < expiryThreshold &&
    //           config.url.indexOf("GetAuth") < 0 &&
    //           config.url.indexOf("GetTeacherState") < 0 &&
    //           config.url.indexOf("renewAuth") < 0
    //         ) {
    //           console.log("expired");
    //           this.setState({ showlogin: true, expirytime: expiryasstring });
    //           throw new axios.Cancel("Token expiring");
    //         }
    //       }
    //       catch{

    //       }
        
    //       return config;
    //     }
        
    //   },
    //   function (error) {
    //     return Promise.reject(error);
    //   }
    // );
  }
  

  authenticate() {
   // alert("starting auth");
    Providers.globalProvider.getAccessToken().then((token) => {
      document.getElementById('errorlog').innerHTML += '<br>appgottoken';
      document.getElementById('errorlog').innerHTML += '<br>'+token;
     // alert("gottoken2");
     // alert(token);
      localStorage.setItem("adal.idtoken", token);
      // this.setState({
      //   authorizationRequestStatus: AuthorizationRequestStatus.Requesting,
      // });
      
      const hostUrl = getQueryParam('SPHostUrl');
      let data = {
        Token: { Token: localStorage.getItem("adal.idtoken"), URL: hostUrl },
      };


      // let testtoken ='eyJ0eXAiOiJKV1QiLCJub25jZSI6IjVqMFpqOV9WLTVyMGJvVFFKQWJfNnoxbzg5d0s4WDR1RHlETjgwdDBURU0iLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zNjMwN2VlMi03YzI1LTRmM2MtODk3Yi1lODQzNGZmZjk1YjAvIiwiaWF0IjoxNjc4MzY4MjAwLCJuYmYiOjE2NzgzNjgyMDAsImV4cCI6MTY3ODM3MjEzNiwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhUQUFBQUpwem1oZCtuNElqVkNOd1BlUDEvdFF4ak9EdndzNlp1bmxTMEVjbDJOczFoMS9GaFlWRlM4MURwUzFrM0d2dTYiLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6Ilpva3JhdGVzIiwiYXBwaWQiOiIxYzYxYmJlMC1hYjA3LTRmZDQtOWRhOS0zMzdmMWNiMDVhN2IiLCJhcHBpZGFjciI6IjAiLCJmYW1pbHlfbmFtZSI6IkFuZGVyc2VuIiwiZ2l2ZW5fbmFtZSI6IkdyeSBCZXJnIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMTkzLjcxLjEyNy4yMTgiLCJuYW1lIjoiR3J5IEJlcmcgQW5kZXJzZW4iLCJvaWQiOiI3ZDgzMjZlYy1lMDgyLTQ4NDUtYmJmOC02MDgzMDc5MTc2ZTkiLCJwbGF0ZiI6IjEiLCJwdWlkIjoiMTAwMzIwMDIwNjM2MUU4RCIsInJoIjoiMC5BUWtBNG40d05pVjhQRS1KZS1oRFRfLVZzQU1BQUFBQUFBQUF3QUFBQUFBQUFBQUpBSkUuIiwic2NwIjoiRWR1QXNzaWdubWVudHMuUmVhZFdyaXRlIEVkdVJvc3Rlci5SZWFkV3JpdGUgRmlsZXMuUmVhZC5BbGwgRmlsZXMuUmVhZFdyaXRlLkFsbCBNeUZpbGVzLlJlYWQgTXlGaWxlcy5Xcml0ZSBTaXRlcy5SZWFkV3JpdGUuQWxsIFVzZXIuUmVhZCBwcm9maWxlIG9wZW5pZCBlbWFpbCIsInNpZ25pbl9zdGF0ZSI6WyJrbXNpIl0sInN1YiI6IjU4cWU5dXFwLXNCbVpWWlk2VmphNlVPTUppX094MG5OZnhYSXNyT3hlMTQiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiRVUiLCJ0aWQiOiIzNjMwN2VlMi03YzI1LTRmM2MtODk3Yi1lODQzNGZmZjk1YjAiLCJ1bmlxdWVfbmFtZSI6ImdyeUBwZGwuYXNwLWhlZG1hcmsubm8iLCJ1cG4iOiJncnlAcGRsLmFzcC1oZWRtYXJrLm5vIiwidXRpIjoiT3FkZHAtbzNCVTZRYkctdWpmMDRBQSIsInZlciI6IjEuMCIsIndpZHMiOlsiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il0sInhtc19zdCI6eyJzdWIiOiJtZTVRZnhZM0dydmxQejJsYm5WVFIydWkyTUJleWRqQjVUSWJoSFhLY1BJIn0sInhtc190Y2R0IjoxMzYzMDQ5NzM0LCJ4bXNfdGRiciI6IkVVIn0.B4YJSfZYVC8uAqqci9frWb7orhLXavehE0BxlP69HSIZ3ZIVm_-SH9NCft25SGSdIhD_-qZVrNQ1sqjbeQDjr7xtlAPrD4l6JN3laq_lBjexYHtsty3O_A7ElV2ID4V9W7Qjaqa1ClnGeQoqB81-PSc1cGEM0Jr9YYQkWQ76V3VUoY3WfG1nuSlGOMzhOLOV8Ix9XitGH9tIBhovjcmECQlu34S9gjxsMQ5qkf28TScwcjmlqBWjL9BCgd5tpE-KPrFKTx5rzpiBkvMVl1uuSwQ836bg99cdJ6pAFfnk_TBPJqiWsJjVzl2tkcufP094i0GsU4eiFY0-FSys2W1THg';
      // let data = {
      //   Token: { Token:testtoken, URL: url },
      // };
      //alert("calling auth");
      //alert(data.Token.Token);
    //  alert(localStorage.getItem("adal.idtoken"));
    document.getElementById('errorlog').innerHTML += '<br>'+'Calling auth';
    document.getElementById('errorlog').innerHTML += '<br>localstorage:'+localStorage.getItem("adal.idtoken");
      this.props
        .getAuth(data)
        .then((response) => {
          document.getElementById('errorlog').innerHTML += '<br>'+'got response';
          document.getElementById('errorlog').innerHTML += '<br>Role '+this.props.role;
        //  alert("fikk svar");
          //console.log("auth", this.props);
          if (this.props.role == "teacher") {
            this.props.getTeacherState().then((response) => {
              this.setState({
                authorizationRequestStatus: AuthorizationRequestStatus.Success,
              });
            });
          }
          if (this.props.role == "student") {
            this.props.getStudentState().then((response) => {
              this.setState({
                authorizationRequestStatus: AuthorizationRequestStatus.Success,
              });
            });
          }
          if (this.props.role == "god") {
            this.setState({
              authorizationRequestStatus: AuthorizationRequestStatus.Success,
            });
          }
        })
        .catch((error) => {
          alert("feiletstart");
          alert(error);
          alert("feiletend");
         // alert(localStorage.getItem("adal.idtoken"));
          this.setState({
            authorizationRequestStatus: AuthorizationRequestStatus.Failed,
          });
        });
    });
    document.getElementById('errorlog').innerHTML += '<br>appgottoken';
  }

  render() {
    console.log("appapp");
    // if(localStorage.getItem('msal.idtoken')&&!localStorage.getItem('adal.idtoken'))
    //   {
    //     console.log();
    //       localStorage.setItem('adal.idtoken',localStorage.getItem('msal.idtoken'));
    //       this.authenticate();

    //   }
    //console.log("rendering", this.state.authorizationRequestStatus);
    // alert('auth');
    // alert(this.state.authorizationRequestStatus);

    switch (this.state.authorizationRequestStatus) {
      case AuthorizationRequestStatus.Success:
        return (
          <ErrorBoundary>
            <DashboardView />
            {this.state && this.state.showlogin && (
              <Dialog
                hidden={false}
                onDismiss={() => this.setState({ showlogin: false })}
                dialogContentProps={{
                  type: DialogType.normal,
                  title: "Timeout",
                  subText: "",
                }}
                styles={{
                  main: [
                    {
                      selectors: {
                        ["@media (min-width: 480px)"]: {
                          maxWidth: "600px",
                          minWidth: "480px",
                        },
                      },
                    },
                  ],
                }}
                modalProps={{
                  titleAriaId: "myLabelId",
                  subtitleAriaId: "mySubTextId",
                  isBlocking: true,
                  containerClassName: "ms-dialogMainOverride",
                }}
              >
                <div>
                  Du er i ferd med å bli logget ut. Klikk oppfrisk for å
                  forlenge innlogging
                </div>
                <DialogFooter>
                  <ActionButton
                    iconProps={{ iconName: "Refresh" }}
                    onClick={() => {
                      this.props.renewAuth().then((resp) => {
                        console.log("renewetToken", resp);
                      });
                      this.setState({ showlogin: false });
                    }}
                  >
                    Oppfrisk
                  </ActionButton>
                </DialogFooter>
              </Dialog>
            )}
          </ErrorBoundary>
        );
      case AuthorizationRequestStatus.Failed:
      //  alert("failed");
       
      //return <UnauthorizedView/>;
      case AuthorizationRequestStatus.NotStarted:
      case AuthorizationRequestStatus.Requesting:
      default:
      //  alert("splasher");
        return <SplashScreenView />;
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  //console.log("state", state);
  return {
    role: state.teacher.user.role,
  };
};

export default connect(mapStateToProps, {
  getAuth,
  getTeacherState,
  getStudentState,
  renewAuth,
})(App);
